import { type ProductData } from "~/domains/product/types/ProductData";
import { type TreeTableNode } from "~/common/components/TreeTable/TreeTable";

export interface FacetValue {
  code: string;
  name: string;
  count: number;
  selected: boolean;
}

/// Stuff for the CategoryFilter
export interface ProductGroup {
  name: string;
  treeNodeUid: string;
  fullFacetUid: string;
  children: ProductGroup[];
  description?: string;
  order: number;
}

export interface TabularColumnConfig {
  name: string;
  hoverTitle: string;
  techValueUID: string;
  sortAsc?: string;
  sortDesc?: string;
  unit?: string;
  visible: boolean;
  originalPosition: number;
}

export enum SearchDisplayMode {
  LIST = "SIMPLE",
  TABULAR = "TECHNICAL",
  SERIES_TREE = "SERIES_TREE",
}

export interface SRPSeriesTreeNode extends TreeTableNode<SRPSeriesTreeNode> {
  minDiameter?: number;
  maxDiameter?: number;
  minImperialDiameter?: number;
  maxImperialDiameter?: number;
  isImperialConverted?: boolean;
  name: string;
  count: number;
  parentCategoryCode: string;
  categoryCode: string;
  isSeries: boolean;
}

export interface TabularViewData {
  id: number;
  weight: string;
  weightImperial: string;
  product: ProductData;
  variantProducts: ProductData[];

  techValues: {
    [techValueUID: string]: {
      value: string;
      abbreviation: string;
      isConverted: boolean;
    };
  };
}

export enum SortDirection {
  ASC = "-asc",
  DESC = "-desc",
}

export type SortOption = {
  code: string;
  isAscdesc?: boolean;
  name: string | undefined;
  showSortingArrow: boolean;
  sortingDirection?: SortDirection;
};
